/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PlanDetails } from './planDetails';


export interface Subscription { 
    readonly created_at: string;
    /**
     * The currency of the subscription. To change this, a new subscription must be created. usd USD eur Euro
     */
    readonly currency: Subscription.CurrencyEnum;
    /**
     * The currently active interval of the subscription monthly Monthly yearly Yearly
     */
    readonly current_interval: Subscription.CurrentIntervalEnum;
    /**
     * The currently active plan of the subscription
     */
    readonly current_plan: string;
    current_plan_details?: PlanDetails;
    /**
     * The ID of the stripe customer
     */
    readonly customer_id: string;
    /**
     * The ID of the subscription
     */
    readonly id: string;
    interval_changes_to: string | null;
    ongoing_stripe_checkout_id?: string | null;
    /**
     * Until when the subscription is payed
     */
    readonly payed_until: string;
    plan_changes_at?: string;
    plan_changes_to: string | null;
    /**
     * For `collection_method=charge_automatically` a subscription moves into `incomplete` if the initial payment attempt fails. A subscription in this status can only have metadata and default_source updated. Once the first invoice is paid, the subscription moves into an `active` status. If the first invoice is not paid within 23 hours, the subscription transitions to `incomplete_expired`. This is a terminal status, the open invoice will be voided and no further invoices will be generated.  A subscription that is currently in a trial period is `trialing` and moves to `active` when the trial period is over.  A subscription can only enter a `paused` status [when a trial ends without a payment method](https://stripe.com/billing/subscriptions/trials#create-free-trials-without-payment). A `paused` subscription doesn\'t generate invoices and can be resumed after your customer adds their payment method. The `paused` status is different from [pausing collection](https://stripe.com/billing/subscriptions/pause-payment), which still generates invoices and leaves the subscription\'s status unchanged.  If subscription `collection_method=charge_automatically`, it becomes `past_due` when payment is required but cannot be paid (due to failed payment or awaiting additional user actions). Once Stripe has exhausted all payment retry attempts, the subscription will become `canceled` or `unpaid` (depending on your subscriptions settings).  If subscription `collection_method=send_invoice` it becomes `past_due` when its invoice is not paid by the due date, and `canceled` or `unpaid` if it is still not paid by an additional deadline after that. Note that when a subscription has a status of `unpaid`, no subsequent invoices will be attempted (invoices will be created, but then immediately automatically closed). After receiving updated payment information from a customer, you may choose to reopen and pay their closed invoices.
     */
    status: string;
    stripe_checkout_expires_at?: string;
    readonly updated_at: string;
}
export namespace Subscription {
    export type CurrencyEnum = 'usd' | 'eur';
    export const CurrencyEnum = {
        Usd: 'usd' as CurrencyEnum,
        Eur: 'eur' as CurrencyEnum
    };
    export type CurrentIntervalEnum = 'monthly' | 'yearly';
    export const CurrentIntervalEnum = {
        Monthly: 'monthly' as CurrentIntervalEnum,
        Yearly: 'yearly' as CurrentIntervalEnum
    };
}


